export class ChartArea {
left?: string | number;
top?: string | number;
width?: string | number;
height?: string | number;
}
